import styled from 'styled-components';

const MainContentStyle = styled.div`
	--categoriesGap: var(--sp2x);
	--distanceTitle: var(--sp3x);
	--distanceTop: var(--sp7x);

	.categories-wrapper {
		display: flex;
		flex-wrap: wrap;
		gap: var(--categoriesGap);
	}

	.title {
		margin: var(--distanceTitle) 0;
	}

	.desc, 
	.shared-wrapper {
		margin-top: var(--distanceTop);
	}

	.shared-wrapper {
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	.date-wrapper {
		display: flex;
		flex-wrap: wrap;
		align-items: center;

		.dot {
			width: var(--sp0-5x);
			height: var(--sp0-5x);
			background-color: var(--red1000);
			border-radius: 50%;
			margin: 0 var(--sp1x);
		}
	}

	/* //! 1920 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeXLMin}) {
		--categoriesGap: var(--sp2x);
		--distanceTitle: var(--sp3x);
		--distanceTop: var(--sp6x);
	}
	/* //! 1536 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeLMin}) {
		--categoriesGap: var(--sp2x);
		--distanceTitle: var(--sp3x);
		--distanceTop: var(--sp6x);
	}
	/* //! 1366 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeMMin}) {
		--categoriesGap: var(--sp2x);
		--distanceTitle: var(--sp3x);
		--distanceTop: var(--sp5x);
	}
	/* //! 1280 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeSMin}) {
		--categoriesGap: var(--sp2x);
		--distanceTitle: var(--sp3x);
		--distanceTop: var(--sp4x);
	}
	/* //! 1024 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeMin}) {
		--categoriesGap: var(--sp2x);
		--distanceTitle: var(--sp3x);
		--distanceTop: var(--sp4x);
	}
	/* //! 768 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeXMin}) {
		--categoriesGap: var(--sp1x);
		--distanceTitle: var(--sp3x);
		--distanceTop: var(--sp4x);
	}
	/* //! Mobile */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeSMin}) {
		--categoriesGap: var(--sp1x);
		--distanceTitle: var(--sp2x);
		--distanceTop: var(--sp3x);

		.shared-wrapper {
			flex-direction: column-reverse;
			gap: var(--sp3x);
		}

		.reserve-btn, 
		.share-wrapper {
			width: 100% !important;
		}
	}
`;
export default MainContentStyle;
